module.exports = __webpack_public_path__ + "static/plume-f70dc790491485605e875a07dc7b6979.mp4";